import { gql } from "utils/urql";
import {
  ArticleBylinesFragment,
  ArticleBylinesAuthorFragment,
} from "types/api";
import styles from "./ArticleBylines.module.scss";
import Authors from "components/Authors";

const AuthorWrapper = ({ url, displayName }: ArticleBylinesAuthorFragment) => {
  return (
    <a
      className={styles.link}
      href={url}
      data-action="click author - byline"
      data-label={url}
    >
      {displayName}
    </a>
  );
};

const ArticleBylines = ({
  authors,
  secondaryByline,
}: ArticleBylinesFragment) => {
  return (
    <div className={styles.root}>
      <address id="byline">
        {authors.length > 0 && `By `}
        <Authors authors={authors} component={AuthorWrapper} />
        {secondaryByline && (
          <div dangerouslySetInnerHTML={{ __html: secondaryByline }} />
        )}
      </address>
    </div>
  );
};

export default ArticleBylines;

ArticleBylines.fragment = gql`
  fragment articleBylinesAuthor on Author {
    id
    url
    displayName
  }

  fragment articleBylines on Article {
    secondaryByline
    authors {
      ...articleBylinesAuthor
    }
  }
`;
